<template>
  <div class="dialogs-content col-md-10 offset-1">
    <div class="dialogs-header p-2">
      <div class="row">
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="Поиск контакта или диалога">
        </div>
        <div class="col-sm-2">
          <button class="btn btn-primary ms-2" @click="openCreateDialog">Создать диалог</button>
        </div>
      </div>
    </div>
    <div class="dialogs-body d-flex">
      <div class="contact-list col-12 col-md-2 h-100 overflow-auto">
        <DialogsList
          :selected-dialog-id="selectedDialog?.id"
          @select-dialog="handleSelectDialog"
        />
      </div>
      <div class="dialog-history col-12 col-md-10 p-0">
        <ChatPanel :selected-dialog="selectedDialog" />
      </div>
    </div>
</div>

<!-- Модалка создания диалога -->
<el-dialog v-model="createDialogVisible" title="Создать диалог" class="col-md-4 col-11">
  <el-form :model="newDialog">
    <el-form-item label="Тип мессенджера">
      <el-select v-model="newDialog.type" placeholder="Выберите тип">
        <el-option label="WhatsApp" value="whatsapp"></el-option>
        <el-option label="Telegram" value="telegram" disabled></el-option>
        <el-option label="Email" value="email" disabled></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="Номер профиля (отправитель)">
      <el-select v-model="newDialog.messenger_id" placeholder="Выберите профиль">
        <el-option
          v-for="messenger in activeAuthorizedMessengers"
          :key="messenger.id"
          :label="messenger.display_name + ' (' + messenger.external_id + ')'"
          :value="messenger.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="Клиент">
      <el-autocomplete
        v-model="clientSearch"
        :fetch-suggestions="searchClientsFn"
        placeholder="Телефон или имя"
        @select="selectClient"
        :trigger-on-focus="false"
        style="width: 100%;"
      >
        <template #default="{ item }">
          <div class="autocomplete-client-item">
            <div>{{ item.fio }}</div>
            <div v-if="item.phone">{{ item.phone }}</div>
          </div>
        </template>
      </el-autocomplete>

      <!-- Отображение выбранного клиента -->
      <el-card
        v-if="newDialog.client_name || newDialog.client_number"
        class="client-selected-block"
      >
        <div class="client-row">
          <el-icon><UserFilled /></el-icon>
          <span>{{ newDialog.client_name }}</span>
        </div>
        <div class="client-row" v-if="newDialog.client_number">
          <el-icon><Phone /></el-icon>
          <span>{{ newDialog.client_number }}</span>
        </div>
        <el-link
          @click="clearSelectedClient"
          type="danger"
          class="client-selected-reset"
        >Сбросить</el-link>
      </el-card>
    </el-form-item>
  </el-form>
  <template #footer>
    <el-button @click="createDialogVisible = false">Отмена</el-button>
    <el-button type="primary" @click="addNewDialog">Создать</el-button>
  </template>
</el-dialog>
</template>

<script>
import DialogsList from '@/components/util/dialogs/DialogsList.vue'
import ChatPanel from '@/components/util/dialogs/ChatPanel.vue'
import { mapState, mapActions } from 'vuex'
import { UserFilled, Phone } from '@element-plus/icons-vue'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Dialogs',
  components: { Phone, UserFilled, DialogsList, ChatPanel },
  data() {
    return {
      selectedDialog: null,
      createDialogVisible: false,
      newDialog: {
        type: 'whatsapp',
        messenger_id: null,
        client_number: '',
        client_name: ''
      },
      searchQuery: '',
      clientSearch: ''
    }
  },
  computed: {
    ...mapState('messengers', ['messengers', 'dialogs']),
    ...mapState('clients', ['search_clients']),
    activeAuthorizedMessengers() {
      return this.messengers.filter(
        m => m.type === this.newDialog.type && m.auth_status === 'authorized' && m.active_status === 'active'
      )
    }
  },
  mounted() {
    // Сначала загружаем messengers и dialogs, затем ищем диалог по dialog_id из URL и передаем полноценный объект
    this.fetchMessengers();
    this.fetchDialogs().then(() => {
      const params = new URLSearchParams(window.location.search);
      const dialogId = params.get('dialog_id');
      if (dialogId) {
        const dialog = this.dialogs.find(d => String(d.id) === dialogId);
        if (dialog) {
          console.log('Открытие диалога по URL:', dialog);
          this.handleSelectDialog(dialog);
        } else {
          console.warn('Диалог с таким ID не найден в dialogs после загрузки');
        }
      }
    });
  },
  methods: {
    ...mapActions('messengers', ['fetchMessengers', 'fetchDialogs', 'createDialog']),
    ...mapActions('clients', ['searchClients']),
    openCreateDialog() {
      this.newDialog = {
        type: 'whatsapp',
        messenger_id: null,
        client_number: '',
        client_name: '',
        client_external_id: ''
      }
      this.createDialogVisible = true
      this.fetchMessengers() // Загружаем список месенджеров при открытии модалки
      this.clientSearch = ''
    },
    async addNewDialog() {
      if (!this.newDialog.messenger_id || !this.newDialog.client_number) {
        this.$notify({ type: 'warning', message: 'Заполните все обязательные поля' })
        return
      }
      try {
        // Передаем client_external_id вместе с остальными полями
        const dialogPayload = {
          ...this.newDialog,
          client_external_id: this.newDialog.client_external_id || ''
        }
        const dialogId = await this.createDialog(dialogPayload)
        this.$notify({ type: 'success', message: 'Диалог успешно создан' })
        this.createDialogVisible = false
        this.handleSelectDialog({ id: dialogId }) // Открываем созданный диалог
      } catch (error) {
        console.error(error)
        this.$notify({ type: 'error', message: 'Ошибка при создании диалога' })
      }
    },
    async searchClientsFn(query, cb) {
      if (!query || query.length < 3) return cb([]);
      await this.searchClients({ query });
      let results = (this.search_clients || []).map(c => ({
        ...c,
        value: c.fio + (c.phone ? ` (${c.phone})` : '')
      }));
      cb(results);
    },
    selectClient(item) {
      this.newDialog.client_number = item.phone || '';
      this.newDialog.client_name = item.fio || '';
      this.newDialog.client_external_id = item.id || '';
      this.clientSearch = item.fio + (item.phone ? ` (${item.phone})` : '');
    },
    clearSelectedClient() {
      this.newDialog.client_number = '';
      this.newDialog.client_name = '';
      this.newDialog.client_external_id = '';
      this.clientSearch = '';
    },
    handleSelectDialog(dialog) {
      if (this.selectedDialog?.id === dialog?.id) return;
      this.selectedDialog = dialog;
      this.$store.commit('socket/SET_SELECTED_DIALOG', dialog);
      if (dialog && dialog.id) {
        this.$store.dispatch('messengers/fetchMessages', { dialog_id: dialog.id });

        // Обновляем URL без перезагрузки
        const url = new URL(window.location);
        url.searchParams.set('dialog_id', dialog.id);
        window.history.replaceState({}, '', url);
      }
    }
  }
}
</script>
<style scoped>
.dialogs-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.dialogs-body {
  height: calc(100% - 55px);
}
.dialogs-header {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.contact-list{
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.dialog-history {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
</style>